import {SelectItemData} from "../models/forms/geec-form-dto.model";

export class TipusIvaUtils {

  static findTipusIva(tipusIvaId: number, tipusIvaOptions: SelectItemData[]): number {
    return tipusIvaOptions.find((tipusIva: SelectItemData) => tipusIva.value === tipusIvaId).data;
  }
}
